export default __webpack_public_path__ + "static/media/styled-components.8c2e7dfe.png";